import React, { Component } from "react";
import { connect } from "react-redux";
import { Table } from '@mawesi-sas/mws_react_component_table';
import FontAwesome from "react-fontawesome";
import Input from '@mawesi-sas/mws_react_component_input';
import { toast } from "react-toastify";

import Box from "../Layout/components/Box";
import ButtonStrip from "../Layout/components/ButtonStrip";
import BoxButton from "../Layout/components/BoxButton";
import ModalCreate from "./components/ModalCreate";

import { getDataFromServer, showHideModalCreate } from "./actions";

const WAIT_INTERVAL = 500;
const ENTER_KEY = 13;

class Usuarios extends Component {
  constructor(props) {
    super(props);
    this.state = { filter: false };
  }

  componentWillMount() {
    this.props.getDataFromServer();
  }

  componentWillUnmount() {}

  handleOnChange = value => {
    clearTimeout(this.timer);
    this.setState({ value });
    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
  };

  handleOnKeyDown = key => {
    if (key.keyCode === ENTER_KEY) {
      clearTimeout(this.timer);
      this.triggerChange();
    }
  };

  triggerChange = () => {
    this.props.getDataFromServer();
  };

  showHideModalCreate = (show, id) => {
    if (this.props.elementos.filter(x => x === "GsUuRYzK").count()) {
      this.props.showHideModalCreate(show, id);
    } else {
      toast.error("Su usuario no tiene permitido ejecutar esta acción", {
        bodyClassName: "toastify-content toastify-danger"
      });
    }
  };

  render() {
    if (!this.props.elementos) return null;

    const buttons = [];
    if (this.props.elementos.filter(x => x === "GsUuRYzK").count())
      buttons.push(
        <BoxButton
          key={`action[0][0]`}
          name="plus"
          onClick={e => this.props.showHideModalCreate(true)}
          title="Nuevo usuario"
        />
      );
    buttons.push(
      <BoxButton
        key={`action[0][1]`}
        name="filter"
        onClick={e => this.setState({ filter: !this.state.filter })}
        title="Filtrar"
      />
    );

    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}
      >
        <div className="row" style={{ height: "100%" }}>
          <div className="col-md-12" style={{ height: "100%" }}>
            <Box title="Usuarios registrados en el sistema" stretch>
              <ButtonStrip actions={buttons} />
              {this.state.filter && (
                <div className="buttonstrip">
                  <Input
                    type="text"
                    reducer="usuarios"
                    path="filter"
                    afterChange={this.handleOnChange}
                    onKeyDown={this.handleOnKeyDown}
                    placeholder="Filtrar..."
                  />
                </div>
              )}
              <div className="box-content" style={{ flex: 1, height: 0 }}>
                <Table
                  reducer="usuarios"
                  table="usuarios"
                  take={100}
                  columns={[
                    {
                      ID: 1,
                      CAPTION: "Username",
                      TYPE: "custom",
                      RENDER_ROW: reg => {
                        return (
                          <span
                            style={{
                              color: "#4f9fcf",
                              cursor: "pointer"
                            }}
                            onClick={e => {
                              e.stopPropagation();
                              this.showHideModalCreate(
                                true,
                                reg.get("id3n71f13r")
                              );
                            }}
                          >
                            {reg.getIn("username".split("."))}
                          </span>
                        );
                      }
                    },
                    {
                      ID: 2,
                      CAPTION: "Nombre",
                      VALUE: "name",
                      TYPE: "text"
                    },
                    {
                      ID: 3,
                      CAPTION: "Email",
                      VALUE: "email",
                      TYPE: "text"
                    },
                    {
                      ID: 4,
                      CAPTION: "Area",
                      VALUE: "area",
                      TYPE: "text"
                    },
                    {
                      ID: 5,
                      CAPTION: "Extension",
                      VALUE: "extension",
                      TYPE: "text"
                    },
                    {
                      ID: 6,
                      CAPTION: "Rol",
                      VALUE: "roles.0.name",
                      TYPE: "text"
                    },
                    {
                      ID: 7,
                      CAPTION: "Estado",
                      WIDTH: 60,
                      TYPE: "custom",
                      RENDER_ROW: reg => (
                        <div
                          style={{
                            textAlign: "center"
                          }}
                        >
                          <FontAwesome
                            name={`${
                              Number(reg.get("active")) ? "check-" : ""
                            }square`}
                          />
                        </div>
                      )
                    }
                  ]}
                  onCambiarPagina={pg => this.props.getDataFromServer(pg)}
                />
              </div>
            </Box>
          </div>
        </div>
        <ModalCreate />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    elementos: state.layout.get("elementos")
  };
}

const mapDispatchToProps = {
  getDataFromServer,
  showHideModalCreate
};

export default connect(mapStateToProps, mapDispatchToProps)(Usuarios);
